import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired feature: send old links somewhere useful. Data is kept.
export const Route = createFileRoute("/admin/future-readiness")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", replace: true, statusCode: 301 });
  },
});
